import { render, staticRenderFns } from "./ExamFindings.vue?vue&type=template&id=4c16dacd"
import script from "./ExamFindings.vue?vue&type=script&lang=js"
export * from "./ExamFindings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports